import { __assign, __rest } from "tslib";
import React from 'react';
import { conditionalClassList } from '@at/formatter-utils/lib/class-name-utils/class-name.util';
import { Badge } from './badge/badge';
import * as Styled from './badge-group.styled';
export var BadgeGroup = function (_a) {
    var content = _a.content, additionalClass = _a.additionalClass, attributes = _a.attributes, _b = _a.className, className = _b === void 0 ? '' : _b, otherHTMLProperties = __rest(_a, ["content", "additionalClass", "attributes", "className"]);
    var classList = conditionalClassList(!!additionalClass && additionalClass, !!className && className);
    return (React.createElement(Styled.BadgeGroupWrapper, __assign({ className: classList }, attributes, otherHTMLProperties), content.map(function (_a, index) {
        var text = _a.text, hiddenText = _a.hiddenText, category = _a.category, className = _a.className;
        return (React.createElement(Styled.BadgeGroupItem, { key: index },
            React.createElement(Badge, { text: text, hiddenText: hiddenText, category: category, className: className })));
    })));
};
